// MARK://dhk8/pos/components/PosRealtimeProvider
// Monta el canal realtime del staff (packages/realtime) cuando hay sesión.
// Apunta al gateway dhk8-pos-realtime desplegado en green. Si no hay sesión,
// pasa los hijos tal cual (RequireAuth ya bloquea las páginas internas), así el
// WsClient nunca intenta conectar sin token.
import type { ReactNode } from 'react'
import { RealtimeProvider } from '@dockethub/realtime'
import { useAuthStore } from '../stores/auth-store.js'
import { getStoredJwt } from '../lib/api.js'
import { apiBase } from '../lib/api-origin.js'

/**
 * URL WS del gateway: `apiBase()` es `https://api.X.tld/v1`; el ingress dedicado
 * enruta `/v1/dhk8-pos-realtime/ws` al servicio (rewrite → el server ve `/ws`).
 * `http→ws` / `https→wss` (replace del prefijo cubre ambos).
 */
function realtimeWsUrl(): string {
  return apiBase().replace(/^http/, 'ws') + '/dhk8-pos-realtime/ws'
}

export function PosRealtimeProvider({ children }: { children: ReactNode }): ReactNode {
  // activeTenantId() cambia en login/logout/switch-env → re-render + reconexión.
  const tenantId = useAuthStore((s) => s.activeTenantId())
  const token = getStoredJwt()
  if (tenantId === null || token === null || token.length === 0) {
    return <>{children}</>
  }
  return (
    <RealtimeProvider url={realtimeWsUrl()} token={token}>
      {children}
    </RealtimeProvider>
  )
}
